/* Rove Next AR: turns an Expivi configuration into Shopify cart lines.
   Shared by the AR viewer page and the saved-scenes page. Both set
   window.RN_AR = { apiBase, storeId } before this loads.

   The Expivi option names and values are sent to the Rove API, which answers
   with the Shopify variant for each configured product. The cart write goes
   through window.fetch, so rn-pdp-cart.js refreshes and opens the cart drawer
   on its own. */
(function () {
  var cfg = window.RN_AR || {};

  var ALLOWED_ATTRIBUTES = new Set([
    'WOOD FINISHES', 'WOOD FINISH', 'FINISHES', 'SURFACES', 'SURFACE', 'SIZE',
    'COLOR', 'ORIENTATION', 'FABRIC', 'OUTDOOR RATTAN', 'OUTDOOR FRAME FINISH',
    'SEAT COLORS', 'OUTDOOR FABRICS', 'EXTENSIONS'
  ]);

  function normalize(value) {
    if (!value || typeof value !== 'string') return '';
    return value.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function extractOptionValues(configuredProduct) {
    var attributes = configuredProduct && (configuredProduct.attributes ||
      (configuredProduct.configuration && configuredProduct.configuration.attributes));
    if (!Array.isArray(attributes)) return null;

    var options = attributes
      .filter(function (a) {
        return a && a.attribute_name && ALLOWED_ATTRIBUTES.has(a.attribute_name.toUpperCase().trim());
      })
      .map(function (a) { return normalize(a.attribute_value_name); })
      .filter(Boolean);

    if (!options.length) return null;
    return { catalogue_id: String(configuredProduct.catalogue_id == null ? '' : configuredProduct.catalogue_id), options: options };
  }

  async function addConfigurationToCart(configuredProducts) {
    if (!Array.isArray(configuredProducts) || !configuredProducts.length) {
      throw new Error('There is nothing configured to add.');
    }

    var payload = configuredProducts
      .map(extractOptionValues)
      .filter(function (p) { return p && p.options.length; });
    if (!payload.length) throw new Error('None of the selected options could be matched to a product.');

    var res = await fetch(cfg.apiBase + '/api/scenes/expivi-products', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ products: payload, store_id: cfg.storeId })
    });
    var data = await res.json();
    if (!data.success || !Array.isArray(data.products) || !data.products.length) {
      throw new Error('These options are not available to buy yet.');
    }

    var items = data.products
      .filter(function (p) { return p.variant_id; })
      .map(function (p) { return { id: String(p.variant_id).split('/').pop(), quantity: 1 }; });
    if (!items.length) throw new Error('These options are not available to buy yet.');

    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    var body = await addRes.json();
    if (!addRes.ok) throw new Error(body.description || 'Could not add to cart.');
    return body;
  }

  window.RNAR = { extractOptionValues: extractOptionValues, addConfigurationToCart: addConfigurationToCart };
})();
